/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */


export const GOOGLE_MAP_URL = 'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,places&key=AIzaSyBo6Wks9tLnShQCf72cljVFh0x078gI_MA';



// WEBPACK FOOTER //
// ./src/app/constants.ts